@if ({
  state: facetState$ | async,
  currentFacetValues: currentFacetValues$ | async,
  displayFacetFormError: displayFacetFormError$ | async,
  }; as content) {
  <button
    class="heading"
    (click)="toggleGroup($event)"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-label]="'productFacetNavigation.filterBy.name' | cxTranslate: { name: facet.name }"
    >
    {{ facet.name }}
    <cx-icon class="collapse-icon" [type]="collapseIcon"></cx-icon>
    <cx-icon class="expand-icon" [type]="expandIcon"></cx-icon>
  </button>
  @if (facet.enableFacetFilter) {
    <form class="container-front-filter" [formGroup]="form" (submit)="submit()">
      <div class="form-group m-0">
        <label class="m-0">
          <span class="label-content">From:</span>
          <input
            class="form-control m-0"
            type="text"
            name="from"
            maxlength="10"
            placeholder="..."
            formControlName="from"
            mask="separator.2"
            [allowNegativeNumbers]="true"
            thousandSeparator=","
            decimalMarker="."
            (keydown.enter)="submit()"
            />
          </label>
        </div>
        <div class="form-group m-0">
          <label class="m-0">
            <span class="label-content">To:</span>
            <input
              class="form-control m-0"
              type="text"
              name="to"
              maxlength="10"
              placeholder="..."
              formControlName="to"
              mask="separator.2"
              [allowNegativeNumbers]="true"
              thousandSeparator=","
              decimalMarker="."
              (keydown.enter)="submit()"
              />
            </label>
          </div>
          @if (form.get('from')?.value || form.get('to')?.value) {
            <button type="button" class="btn btn-outline-primary" title="Reset" (click)="reset()">
              <span class="material-symbols-outlined d-flex"> close </span>
            </button>
          }
          <button class="btn btn-primary" title="Filter">
            <span class="material-symbols-outlined d-flex"> filter_alt </span>
          </button>
        </form>
        @if (content.displayFacetFormError?.length) {
          <div class="form-error-container">
            @for (error of content.displayFacetFormError; track error) {
              <p class="text-danger h7">{{ error }}</p>
            }
          </div>
        }
      }
      <div>
        @for (value of content.currentFacetValues | slice: 0 : getMaxItens(); track value) {
          <a
            #facetValue
            routerLink="./"
            [queryParams]="getLinkParams(value)"
            class="value"
            [class.selected]="value.selected"
            [cxFocus]="{ key: value.name }"
            (keydown.space)="openLink($any($event))"
            [attr.role]="facet.multiSelect ? 'checkbox' : null"
            [attr.aria-checked]="facet.multiSelect ? value.selected : null"
            attr.aria-label="{{ 'productFacetNavigation.ariaLabelItemsAvailable' | cxTranslate: { name: value.name, count: value.count } }}"
            >
            <span aria-hidden="true">
              {{ value.name }} <span aria-hidden="true" class="count">{{ value.count }}</span>
            </span>
          </a>
        }
        @if (!facet.enableFacetFilter) {
          <div class="more">
            @for (value of content.currentFacetValues | slice: content.state?.topVisible ?? 0 : content.state?.maxVisible; track value) {
              <a
                #facetValue
                routerLink="./"
                [queryParams]="getLinkParams(value)"
                class="value"
                [class.selected]="value.selected"
                [cxFocus]="{ key: value.name }"
                (keydown.space)="openLink($any($event))"
                >
                <span>
                  {{ value.name }}<span class="count">{{ value.count }}</span>
                </span>
              </a>
            }
            @if (!facet.enableFacetFilter) {
              @if (content.state!.maxVisible && content.state!.topVisible && content.state!.maxVisible > content.state!.topVisible) {
                <button
                  (click)="decreaseVisibleValues()"
                  [cxAtMessage]="'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate"
                  aria-expanded="true"
                  attr.aria-label="{{ 'productFacetNavigation.ariaLabelShowLess' | cxTranslate }}"
                  class="cx-action-link"
                  [cxFocus]="{ key: 'moreorless' }"
                  >
                  {{ 'productList.showLess' | cxTranslate }}
                </button>
              }
              @if (
                content.state!.maxVisible &&
                content.currentFacetValues &&
                content.state!.maxVisible > 0 &&
                content.state!.maxVisible < content.currentFacetValues.length
                ) {
                <button
                  (click)="increaseVisibleValues()"
                  [cxAtMessage]="'productFacetNavigation.increaseOptionsVisibility' | cxTranslate"
                  aria-expanded="false"
                  attr.aria-label="{{ 'productFacetNavigation.ariaLabelShowMore' | cxTranslate }}"
                  class="cx-action-link"
                  [cxFocus]="{ key: 'moreorless' }"
                  >
                  {{ 'productList.showMore' | cxTranslate }}
                </button>
              }
            }
          </div>
        }
      </div>
    }
